import { render } from "./LoaderComponent.vue?vue&type=template&id=8e58fe38&ts=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=ts"
export * from "./LoaderComponent.vue?vue&type=script&lang=ts"

import "./LoaderComponent.vue?vue&type=style&index=0&id=8e58fe38&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__